import { render, staticRenderFns } from "./FilesListModal.vue?vue&type=template&id=436fdde8&scoped=true&"
import script from "./FilesListModal.vue?vue&type=script&lang=ts&"
export * from "./FilesListModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436fdde8",
  null
  
)

export default component.exports